import React from 'react'
import agent from '../agent'
import ProductList from './widgets/ProductList'
import CategoryLogList from './widgets/CategoryLogList'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { Link } from 'react-router-dom'
import {
    CATEGORY_DETAIL_PAGE_LOADED,
    CATEGORY_DETAIL_PAGE_UNLOADED,
} from '../constants/actionTypes'
import { store } from '../store'
import { push } from 'react-router-redux'

const Promise = global.Promise;
const { RangePicker } = DatePicker;


const mapStateToProps = state => ({
    ...state.category,
    currentUser: state.common.currentUser,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: CATEGORY_DETAIL_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: CATEGORY_DETAIL_PAGE_UNLOADED }),
});

class CategoryDetail extends React.Component {
    constructor() {
        super()
    }

    componentWillMount() {
        const payload = Promise.all([
            agent.Categories.getDetail(this.props.match.params.key),
            agent.Categories.getCategoryProducts(this.props.match.params.key),
            agent.Categories.getCategoryLogs(this.props.match.params.key)
        ])
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        if (!this.props.category) {
            return (
                <Loading />
            )
        }

        return (
            <div class='pane'>
                <Link className="crumb" to={`/categories/user/${this.props.category.userkey}`}>&laquo; back to categories</Link>
                <h1>Category Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Key:</label> <span><Link to={`/category/${this.props.category.key}/edit`}>{this.props.category.key}</Link></span>
                    </div>
                    <div className="infoPair">
                        <label>Name:</label> <span>{this.props.category.name}</span>
                    </div>
                </div>

                <div className="infoGroup">
                    <div className="infoAction">
                        <h2>Product List</h2>
                        <ProductList products={this.props.products} loading={this.props.loading} />
                    </div>
                </div>
                <div className="infoGroup">
                    <div className="infoAction">
                        <h2>Update Logs</h2>
                        <CategoryLogList logs={this.props.logs} loading={this.props.loading} />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetail);



// WEBPACK FOOTER //
// ./src/components/CategoryDetail.js